import React from "react";

const AssessmentNavigation = ({
  currentIndex,
  totalAssessments,
  isLoading,
  onBack,
  onNext,
}) => {
  return (
    <div className="btn-assessment">
      <button
        className="theme-common-btn-big"
        onClick={onBack}
        disabled={isLoading}
        hidden={currentIndex === 0}
      >
        Back
      </button>
      <button
        className="theme-common-btn-big ml-3"
        onClick={onNext}
        type="button"
        disabled={isLoading}
      >
        {currentIndex < totalAssessments - 1 ? "Next" : "Finish"}
      </button>
    </div>
  );
};

export default AssessmentNavigation;
